import { render, staticRenderFns } from "./footer_content.vue?vue&type=template&id=2a5d2b0e&"
import script from "./footer_content.vue?vue&type=script&lang=js&"
export * from "./footer_content.vue?vue&type=script&lang=js&"
import style0 from "./footer_content.vue?vue&type=style&index=0&id=2a5d2b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports